import service from "@/plugins/request";

export function apiCalendarAdd(data) {
  return service({
    url: "/v1/protected/calendar/add",
    method: "post",
    data
  });
}

export function apiCalendarDelete(data) {
  return service({
    url: "/v1/protected/calendar/delete",
    method: "post",
    data
  });
}

export function apiCalendarEdit(data) {
  return service({
    url: "/v1/protected/calendar/edit",
    method: "post",
    data
  });
}

export function apiCalendarList(data) {
  return service({
    url: "/v1/protected/calendar/page-list",
    method: "post",
    data
  });
}

export function apiForeCalendarList(params) {
  return service({
    url: "/v1/calendar/query-list",
    method: "get",
    params
  });
}
